import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import noop from 'lodash/noop';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Button from 'yoda-core-components/lib/components/Button/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { messageTypes } from './CMMessages.config';

import * as styles from './CMMessagePopup.css';

const cx = classNames.bind(styles);

const CMMessagePopup = (props) => {
    const { type, title, className, iconComponent } = props;
    return (
        <div className={`${cx('message-popup', type, className)} ${dt(['text-center'])}`}>
            <ModalBox
                showModal={props.showErrorPopUp}
                onClose={props.onClose}
                defaultHeader
                automationId="message-dialog"
                modalTheme={`${cx('messageModalTheme')} ${dt([
                    'md:w-[375px]',
                    'xl:w-[688px]',
                    'lg:w-[608px]',
                    'smOnly:max-h-screen',
                ])}`}
                modalContentTheme={`${cx('messageModalContentTheme`')} ${dt([
                    'text-center',
                    'sm:mt-[21.34px]',
                    'lg:mt-[22.1px]',
                ])}`}
                modalOverlayTheme={`${cx('messageModalOverlayTheme')} ${dt(['z-[101]'])}`}
            >
                <div className={cx('message-content`')}>
                    {/* If icon not required we can remove this code */}
                    <div>
                        {iconComponent ? (
                            <Icon
                                iconType="svg"
                                automationId="apply-coupon-dialog-icon"
                                width="96px"
                                height="96px"
                                viewBox="0 0 96 96"
                            >
                                {iconComponent}
                            </Icon>
                        ) : (
                            ''
                        )}
                    </div>
                    <div
                        className={`${cx('message-title')} ${dt([
                            'mb-6',
                            'text-black',
                            'text-small',
                            'font-normal',
                            'sm:text-left',
                            'lg:text-center',
                            'font-open-sans',
                        ])}`}
                    >
                        {title}
                    </div>
                    <div className={`${cx('message-body')} ${dt(['mt-6'])}`}>
                        <Button
                            type="button"
                            buttonType="Primary"
                            size=""
                            onClick={props.onClose}
                            className={`${cx('coupon-error-btn')} ${dt([
                                'my-0',
                                'mx-auto',
                                'max-h-12',
                                'sm:w-full',
                                'lg:w-[300px]',
                                'lg:h-12',
                                'sm:text-base',
                                'sm:leading-6',
                                'sm:pt-2',
                                'sm:pb-2',
                                'lg:text-[20px]',
                                'lg:leading-[28px]',
                                'lg:pb-[10px]',
                            ])}`}
                        >
                            OK
                        </Button>
                    </div>
                </div>
            </ModalBox>
        </div>
    );
};
CMMessagePopup.propTypes = {
    type: noop,
    title: PropTypes.string,
    onClose: PropTypes.func,
    className: PropTypes.string,
};

CMMessagePopup.defaultProps = {
    type: messageTypes?.error,
    title: '',
    onClose: noop,
    className: '',
};
export default React.memo(CMMessagePopup);
